
















































import { Vue, Component } from "../vue-ext";
// import JsonRpcClient from "./../utils/JsonRpcClient";
import { HousingCompany, User, Message, Request } from "../models";
import Service from "../service/Service";

@Component
export default class ChooseHousingCompanyView extends Vue {
    private search = "";
    private companies: HousingCompany[] = [];
    private selectedHousingCompany: HousingCompany | null = null;
    private user: User | null = null;
    private showNoCompanies: boolean;
    private allOwnMessages: Message[] | null = null;
    private allRequests: Request[] | null = null;
    private open: boolean = false;
    private loading: boolean = false;

    private async created() {
        this.companies = await this.service.housingCompany.List();
        this.user = this.root.getCurrentUser() as User;

        this.allOwnMessages = await this.root.updateAllOwnMessages();
        this.allRequests = await this.root.updateRequests();
    }

    private mounted() {
        if (!this.root.isAuthenticated()) {
            this.$router.push("/");
        }
    }

    private filteredCompanies(own: boolean) {
        if (this.companies) {
            const filteredCompanies = this.companies.filter(c => c.isAvailable && c.name.toLowerCase().includes(this.search.toLowerCase()));
            let housingCompanyIds = [] as number[];

            if (this.user && filteredCompanies) {
                housingCompanyIds = this.user.accounts.map(a => a.housingCompanyId);
            }

            this.showNoCompanies = filteredCompanies.length <= 0 && this.search.length >= 2;

            if (own) {
                let result = this.companies.filter(c => housingCompanyIds.includes(c.housingCompanyId));

                if (this.allOwnMessages && this.allRequests) {
                    for (let i = 0; i < result.length; i++) {
                        result[i].unreadMessageCount 
                            = this.allOwnMessages.filter(m => m.housingCompanyId === result[i].housingCompanyId && m.readOn === null).length
                            + this.allRequests.filter(r => r.housingCompanyId === result[i].housingCompanyId && r.readOn === null).length;
                    } 
                }

                return result;
            } else {
                return this.search.length >= 2 && this.open
                    ? filteredCompanies.filter(c => !housingCompanyIds.includes(c.housingCompanyId)) 
                    : null;
            }
        }
    }

    private selectHousingCompany(housingCompany: HousingCompany) {
        this.selectedHousingCompany = housingCompany;
    }

    private async next() {
        this.loading = true;
        if (this.selectedHousingCompany) {
            if (!this.selectedHousingCompany.isAvailable) {
                await this.root.setHousingCompany(this.selectedHousingCompany, false);
                this.$router.push("/housing-company-not-available");
            } else if (this.root.isAuthenticated()) {
                await this.root.setHousingCompany(this.selectedHousingCompany, true);
                this.$router.push("/content/welcome");
            } else {
                this.$router.push("/input-email");
            }
        }
        this.loading = false;
    }

    private openSearch() {
        this.open = !this.open;

        if (this.open) {
            setTimeout(() => { 
                let searchField = <HTMLInputElement>this.$refs.search;
                searchField.focus();
            }, 100);
        }
    }

    // private testText = "TEST GET";
    // private testTextPost = "TEST POST";
    // private async test() {
    //     this.testText = JSON.stringify(await this.service.authentication.test());
    //     console.log(this.testText);
    // }
    // private async testpost() {
    //     this.testTextPost = JSON.stringify(await this.service.authentication.testpost());
    //     console.log(this.testTextPost);
    // }
}
